/**
 * Construye un label legible para una variante de Vita.
 *
 * Fuente de cada pieza:
 *   - País: nombre del objeto VitaCountry (DB) — admin-managed.
 *   - Moneda destino: la calcula el backend desde Vita (/prices).
 *   - Método/sufijo (BREB, WIRES, RTP...): diccionario acá, términos de
 *     banca oficiales por método (no por país).
 *
 * Si falta info, cae a fallbacks razonables (ISO-2, raw suffix) sin romper.
 *
 * Mantener en paralelo con el util del backend:
 * `aguacate-wallet-api/src/modules/integrations/vita-wallet/utils/vita-variant-label.util.ts`
 */

export const VITA_METHOD_LABELS: Record<string, string> = {
  USD: 'USD',
  EUR: 'EUR',
  COP: 'COP',
  BREB: 'BREB (instantáneo)',
  WIRES: 'Wires',
  RTP: 'RTP',
  ACH: 'ACH',
  PIX: 'PIX (instantáneo)',
  SEPA: 'SEPA',
};

export const VITA_SPECIAL_LABELS: Record<string, string> = {
  SWIFTUSD: 'SWIFT · USD',
};

export interface VitaVariantLabelContext {
  countryName?: string | null;
  currency?: string | null;
}

export function buildVitaVariantLabel(
  rawCode: string | null | undefined,
  ctx: VitaVariantLabelContext = {},
): string {
  if (!rawCode) return '';
  const code = rawCode.toUpperCase();

  if (VITA_SPECIAL_LABELS[code]) return VITA_SPECIAL_LABELS[code];

  if (code.length < 2) return code;

  const iso = code.substring(0, 2);
  const suffix = code.substring(2);

  const countryName = (ctx.countryName || '').trim() || iso;

  if (!suffix) {
    const currency = (ctx.currency || '').trim().toUpperCase();
    return currency ? `${countryName} · ${currency}` : countryName;
  }

  const methodLabel = VITA_METHOD_LABELS[suffix] || suffix;
  return `${countryName} · ${methodLabel}`;
}
